"use client";

import ProductsFeed from "./products-feed";

const ProductListing = ({ disableSearchFilter }: { disableSearchFilter?: boolean }) => {
	return (
		<>
			<div className="relative">
				<div className="listing-hero-clip-path absolute -z-10 h-full max-h-[938px] w-full" />

				<div className="mx-auto px-4 pb-8 lg:px-0">
					<ProductsFeed disableSearchFilter={disableSearchFilter} />
				</div>
			</div>
		</>
	);
};

export default ProductListing;
